import React from 'react';
import TrackingWidget from './TrackingWidget';
import CalculatorWidget from './CalculatorWidget';
import '../../styles/app/QuickActionsSection.css';

const QuickActionsSection: React.FC = () => {
    return (
        <section className="quick-actions-section">
            <div className="quick-actions-container">

                {/* Left: Tracking */}
                <div className="quick-action-col">
                    <TrackingWidget />
                </div>

                {/* Right: Calculator */}
                <div className="quick-action-col">
                    <CalculatorWidget />
                </div>

            </div>
        </section>
    );
};

export default QuickActionsSection;
